import type { CommunicationFileGateway } from '@/application/port/out/CommunicationFileGateway';
import type { UploadCommunicationFileUseCase, DownloadCommunicationFileUseCase } from '@/application/port/in/CommunicationFileUseCase';
import type { UploadCommunicationAttachment, CommunicationFileReference } from '@/domain/model/CommunicationFile';
export class UploadCommunicationFile implements UploadCommunicationFileUseCase {
  constructor(private readonly gateway: CommunicationFileGateway) {}
  execute(command: UploadCommunicationAttachment) { return this.gateway.upload(command); }
}
export class DownloadCommunicationFile implements DownloadCommunicationFileUseCase {
  constructor(private readonly gateway: CommunicationFileGateway) {}
  execute(reference: CommunicationFileReference) { return this.gateway.download(reference); }
}
